import {PresetSchemaKind} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const presetSchema = typedQuery(["tprm", "presetSchema", param<PresetSchemaKind>("kind")], async kind => {
  return await api.tprm.presetSchemas.get(kind);
});
